<form class="form vc-admin-form vc-admin-calendar-form" (ngSubmit)="execute()">
  <section class="vc-admin-form__section">
    <div class="grid vc-admin-calendar-form__grid">
      <div class="col-12 lg:col-6">
        <div class="field">
          <label for="calendar-name">{{ "COMMON.CALENDAR.NAME" | translate }} *</label>
          <input
            id="calendar-name"
            pInputText
            pSize="small"
            name="name"
            [(ngModel)]="payload.name"
            fluid
          />
          <small class="vc-admin-calendar-form__hint">
            {{ "ADMIN.SITES.CALENDARS.DETAILS.NAME_HINT" | translate }}
          </small>
          <small id="calendar-name-help" class="p-error" *ngIf="errors.name">
            {{ errors.name | translate }}
          </small>
        </div>
      </div>

      <div class="col-12 sm:col-6 lg:col-3">
        <div class="field">
          <label for="calendar-precision">{{ "COMMON.CALENDAR.PRECISION" | translate }} *</label>
          <input
            id="calendar-precision"
            pInputText
            pSize="small"
            name="precision"
            type="number"
            min="5"
            step="5"
            [(ngModel)]="payload.precision"
            fluid
          />
          <small class="vc-admin-calendar-form__hint">
            {{ "ADMIN.SITES.CALENDARS.DETAILS.PRECISION_HINT" | translate }}
          </small>
          <small id="calendar-precision-help" class="p-error" *ngIf="errors.precision">
            {{ errors.precision | translate }}
          </small>
        </div>
      </div>

      <div class="col-12 sm:col-6 lg:col-3">
        <div class="field">
          <label for="calendar-default-professional">
            {{
              "ADMIN.SITES.CALENDARS.DETAILS.DEFAULT_PROFESSIONAL_LABEL"
                | translate
            }}
          </label>
          <p-select
            inputId="calendar-default-professional"
            styleClass="vc-admin-calendar-form__professional-select"
            size="small"
            [appendTo]="'body'"
            [options]="professionals"
            [(ngModel)]="payload.users_id"
            (ngModelChange)="onDefaultProfessionalChanged($event)"
            [showClear]="true"
            [loading]="loadingProfessionals"
            [optionLabel]="'fullName'"
            [optionValue]="'id'"
            [placeholder]="
              'ADMIN.SITES.CALENDARS.DETAILS.DEFAULT_PROFESSIONAL_PLACEHOLDER'
                | translate
            "
            name="users_id"
            fluid
          ></p-select>
          <small class="vc-admin-calendar-form__hint">
            {{
              "ADMIN.SITES.CALENDARS.DETAILS.DEFAULT_PROFESSIONAL_HINT"
                | translate
            }}
          </small>
          <small class="vc-admin-calendar-form__hint" *ngIf="!loadingProfessionals && professionals.length === 0">
            {{
              "ADMIN.SITES.CALENDARS.DETAILS.DEFAULT_PROFESSIONAL_NO_USERS"
                | translate
            }}
          </small>
        </div>
      </div>

      <div class="col-12">
        <div class="field">
          <label for="calendar-professionals">
            {{
              "ADMIN.SITES.CALENDARS.DETAILS.PROFESSIONALS_LABEL"
                | translate
            }}
          </label>
          <p-multiselect
            inputId="calendar-professionals"
            styleClass="vc-admin-calendar-form__members-select"
            size="small"
            [appendTo]="'body'"
            [options]="professionals"
            [(ngModel)]="payload.professional_users_ids"
            [loading]="loadingProfessionals"
            [optionLabel]="'fullName'"
            [optionValue]="'id'"
            [selectedItemsLabel]="
              'ADMIN.SITES.CALENDARS.DETAILS.PROFESSIONALS_SELECTED'
                | translate
            "
            [maxSelectedLabels]="professionalSelectionLimit"
            [display]="'chip'"
            [showClear]="true"
            [defaultLabel]="
              'ADMIN.SITES.CALENDARS.DETAILS.PROFESSIONALS_PLACEHOLDER'
                | translate
            "
            name="professional_users_ids"
          ></p-multiselect>
          <small class="vc-admin-calendar-form__hint">
            {{
              "ADMIN.SITES.CALENDARS.DETAILS.PROFESSIONALS_HINT"
                | translate
            }}
          </small>
        </div>
      </div>
    </div>
  </section>

  <footer class="vc-admin-calendar-form__actions">
    <app-delete-button-calendar
      *ngIf="allowDelete"
      [payload]="payload"
      [onDelete]="onUpdate"
    ></app-delete-button-calendar>

    <button
      pButton
      type="submit"
      class="p-button-sm"
      [label]="(submitting ? 'COMMON.SAVING' : 'COMMON.SAVE') | translate"
      [loading]="submitting"
      [disabled]="submitting"
    ></button>
  </footer>
</form>
